import Vue from 'vue';
import VueRouter from 'vue-router';
import Dashboard from '../views/Dashboard.vue';
import Project from '../views/Project.vue';
import Login from '../views/Login.vue';
import Profile from '../views/Profile.vue';

Vue.use(VueRouter);
const routes = [
  {
    path: '/',
    redirect: { name: 'Login' },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
  },
  {
    path: '/dashboard/project',
    name: 'Project',
    component: Project,
    props: (route) => ({
      ...route.params
    })
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    props: (route) => ({
      ...route.params
    })
  },
];
const router = new VueRouter({
  mode: 'history',
  base: '/finvote/',
  routes,
  scrollBehavior() {
    return { x: 0, y:0 }
  },
});

export default router;
